import { useFeatureFlagToken } from "../../../hooks/useFeatureFlag";
import {
  FEATURE_FLAG_LABELS,
  FeatureFlagName,
} from "../../../types/feature-flags/featureFlag";
import { Button, ButtonProps, Tooltip } from "@mui/material";

interface FeatureFlagGuardProps extends ButtonProps {
  featureFlag: FeatureFlagName;
  tooltip?: string;
}

export function FeatureFlagButton({
  featureFlag,
  tooltip,
  children,
  disabled,
  ...props
}: Readonly<FeatureFlagGuardProps>) {
  const isFeatureEnabled = useFeatureFlagToken(featureFlag);

  function featureFlagLabel(flag: FeatureFlagName) {
    return FEATURE_FLAG_LABELS[flag].toLocaleLowerCase();
  }

  return (
    <Tooltip
      title={
        isFeatureEnabled
          ? tooltip
          : `You do not have ${featureFlagLabel(featureFlag)} enabled.`
      }
    >
      <span>
        <Button {...props} disabled={!isFeatureEnabled || disabled}>
          {children}
        </Button>
      </span>
    </Tooltip>
  );
}
